@if (feedbackDisabled) {
<div [class.ios]="isIos" class="feedback" (click)="openFeedback()">
  <p>Gi tilbakemelding</p>
</div>
}